import { AxiosRequestConfig } from 'axios';
import { httpConfig } from 'src/lib/modules/http';
import { Api } from 'src/api';
import { ActivityResponse } from './activity.types';
import { ApiQueryObject } from '../../api-query-params';
import { PaginatedResponse } from 'src/api/Client';

const baseUrl = `${httpConfig.options.baseURL}/company-request-action-snapshot-logs`;

const index = (
  params?: ApiQueryObject,
  config?: AxiosRequestConfig,
): Promise<PaginatedResponse<ActivityResponse>> => Api.http.get(baseUrl, { params, ...config });

export { index };
